import { useQuery } from '@tanstack/react-query'

import client from '@/api/client'
import { cardState } from '@/components/common/ResourceStatistic'

import { DASHBOARD_STALE_TIME } from './constants'
import {
  fetchIpStats,
  fetchReadyStorageGb,
  type IpStats,
} from './resourceStatsFetchers'

export type { IpStats }

export function useResourceStats() {
  const storageQuery = useQuery({
    queryKey: ['dashboard', 'readyStorageGb'],
    queryFn: () => fetchReadyStorageGb(client),
    staleTime: DASHBOARD_STALE_TIME,
  })

  const ipsQuery = useQuery({
    queryKey: ['dashboard', 'ipStats'],
    queryFn: () => fetchIpStats(client),
    staleTime: DASHBOARD_STALE_TIME,
  })

  const storage = cardState(storageQuery)
  const ips = cardState(ipsQuery)

  return { storage, ips, queries: [storageQuery, ipsQuery] }
}
